import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NotificationEmailConfig } from '@app/modules/reports/types/report.types';
import { NotificationProfileModel, TemplateType } from '@core/core.types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ApproveReportPrepareEmailComponent } from './approve-report-prepare-email/approve-report-prepare-email.component';
import { ApproveReportPreviewEmailComponent } from './approve-report-preview-email/approve-report-preview-email.component';
import { ApproveReportComponent } from './approve-report/approve-report.component';

enum DialogStep {
  prepareEmail = 'prepare-email',
  previewEmail = 'preview-email',
  approveReport = 'approve-report',
}

@Component({
  selector: 'app-approve-report-dialog',
  imports: [
    TranslatePipe,
    ApproveReportPrepareEmailComponent,
    ApproveReportPreviewEmailComponent,
    ApproveReportComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './approve-report-dialog.component.html',
})
export class ApproveReportDialogComponent {
  protected modalRef = inject(NgbActiveModal);

  public kitId = signal<string>(null);
  public report = signal<Report>(null);
  public notificationProfile = signal<NotificationProfileModel>(null);
  public templateType = signal<TemplateType>(null);
  public emailTemplate = signal<{
    serviceName: string;
    predefinedRecipients: any;
    subject: string;
    body: string;
  }>(null);

  protected isLoading = signal<boolean>(false);
  protected step = signal<DialogStep>(DialogStep.prepareEmail);
  protected emailConfig = signal<NotificationEmailConfig>(null);

  protected setEmailConfig(emailConfig: NotificationEmailConfig) {
    this.emailConfig.set(emailConfig);

    if (!emailConfig) {
      this.step.set(DialogStep.approveReport);
    } else {
      this.step.set(DialogStep.previewEmail);
    }
  }

  protected sendEmail(send: boolean) {
    if (send) {
      this.step.set(DialogStep.approveReport);
    } else {
      this.step.set(DialogStep.prepareEmail);
    }
  }

  protected approveReport(approve: boolean) {
    if (approve) {
      this.isLoading.set(true);
      this.modalRef.close({
        recipients: this.emailConfig()?.to,
        ccRecipients: this.emailConfig()?.cc,
        bccRecipients: this.emailConfig()?.bcc,
        body: this.emailConfig()?.body,
        subject: this.emailConfig()?.subject,
        sendEmail: !!this.emailConfig()?.subject,
      });
    } else {
      this.modalRef.close();
    }
  }

  protected readonly DialogStep = DialogStep;
}
